<template>
  <form @submit.prevent="handleSubmit(item)">
    <b-row>
      <b-col>
        <div class="form-group">
          <label
                  for="excmteam_name"
                  class="form-control-label">{{$t('views.excmteam.form.name')}}:</label>
          <input
                  id="excmteam_name"
                  v-model="item.name"
                  :class="['form-control', isInvalid('name') ? 'is-invalid' : '']"
                  type="text"
                  required="true"
                  placeholder=""
                  @input="handleUpdateField('name', $event.target.value)">
          <div
                  v-if="isInvalid('name')"
                  class="invalid-feedback">{{ violations.name }}</div>
        </div>
      </b-col>
    </b-row>
    <template v-if="$route.name === 'EXCMTeamCreate'">
      <b-row v-for="(teamUserDataItem, teamUserDataIndex) in item.teamUserData" v-bind:key="'teamUserDataItem-' + teamUserDataIndex">
        <b-col cols="12" lg="1">
          <h5 class="pt-1 text-center">#{{ teamUserDataIndex + 1 }}</h5>
        </b-col>
        <b-col cols="9" lg="10">
          <div class="form-group">
            <fg-input>
              <el-select
                      class="select-default"
                      :placeholder="$t('views.excmteam.form.userData')"
                      filterable
                      v-model="item.teamUserData[teamUserDataIndex].userData">
                <el-option v-for="option in servicemenOptions"
                           class="select-default"
                           :value="option['@id']"
                           :label="option.name + ' ' + option.surname"
                           :key="option['@id']">
                </el-option>
              </el-select>
            </fg-input>
          </div>
        </b-col>
        <b-col cols="3" lg="1">
          <b-btn class="btn btn-danger mt-0 float-right" @click="removeTeamUserDataItem(teamUserDataIndex)">
            <span v-if="!mobileView">{{ $t('buttons.delete') }}</span>
            <i v-else class="far fa-trash-alt"></i>
          </b-btn>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-btn @click="addTeamUserDataItem()">{{$t('views.excmteam.form.addNewTeamUserData')}}</b-btn>
        </b-col>
      </b-row>
    </template>

    <button type="submit" class="btn btn-success">{{ $t('buttons.submit') }}</button>
  </form>
</template>

<script>
export default {
  props: {
    handleSubmit: {
      type: Function,
      required: true
    },

    handleUpdateField: {
      type: Function,
      required: true
    },

    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },

  data () {
    return {
      servicemenOptions: []
    }
  },

  computed: {
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },

    mobileView () {
      return this.$store.state.mobileView
    },

    violations () {
      return this.errors || {}
    }
  },

  created () {
    this.getServicemen()
  },

  methods: {
    getServicemen () {
      let params = {
        'pagination': false,
        'isCompany': 0,
        'state': 1,
        'idClientType': 5
      }
      this.servicemenOptions = []
      this.$http.get('api/user_datas', {
        params
      })
        .then(response => {
          this.servicemenOptions = response.data['hydra:member']
        })
        .catch(error => {
          if (error.response.status === 400) {
            let text = ''
            for (let i in error.response.data) {
              text += error.response.data[i] + '\n'
            }
            this.$Swal({
              type: 'warning',
              title: text,
              timer: 2500
            })
          }
          console.log(error)
        })
    },

    removeTeamUserDataItem (index) {
      this.item.teamUserData.splice(index, 1)
    },

    addTeamUserDataItem () {
      let item = {
        userData: null
      }
      this.item.teamUserData.push(item)
    },

    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    }
  }
}
</script>
